/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type MediaList_media$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type RecheckMediaList_recheckMedia$ref: FragmentReference;
declare export opaque type RecheckMediaList_recheckMedia$fragmentType: RecheckMediaList_recheckMedia$ref;
export type RecheckMediaList_recheckMedia = {|
  +mediaList: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +recheckStatus: ?string,
        +id: string,
      |}
    |}>,
    +pageInfo: {|
      +hasNextPage: boolean,
      +endCursor: ?string,
    |},
    +$fragmentRefs: MediaList_media$ref,
  |},
  +$refType: RecheckMediaList_recheckMedia$ref,
|};
export type RecheckMediaList_recheckMedia$data = RecheckMediaList_recheckMedia;
export type RecheckMediaList_recheckMedia$key = {
  +$data?: RecheckMediaList_recheckMedia$data,
  +$fragmentRefs: RecheckMediaList_recheckMedia$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "RecheckMediaList_recheckMedia",
  "type": "ExtendedMediaConnection",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": [
          "mediaList"
        ]
      }
    ]
  },
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "count",
      "type": "Int"
    },
    {
      "kind": "RootArgument",
      "name": "cursor",
      "type": "String"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "mediaList",
      "name": "__RecheckMediaList_mediaList_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "MediaConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "MediaEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Media",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "recheckStatus",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "id",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "__typename",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "cursor",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "pageInfo",
          "storageKey": null,
          "args": null,
          "concreteType": "PageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "hasNextPage",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "endCursor",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "FragmentSpread",
          "name": "MediaList_media",
          "args": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '578b5e6d38723f837e1aff54e74479bb';

module.exports = node;
